import {
  maxBreakpoints,
  primaryRegularFont,
  primarySemiBoldFont,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { spacing } = theme;

export const container = css`
  position: absolute;
  top: ${pxToRem(52)};
  left: 0;
  right: 0;
  z-index: 9;
  background-color: ${palette.neutralWhite};

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      padding: 0 ${spacing.xs}px;
    `,
  )};
`;

export const title = css`
  margin: ${spacing.xxl}px 0 0 ${spacing.md}px;
  ${primarySemiBoldFont};
  ${theme.responsiveText.BODY.SM}
  color: ${palette.neutralBrandBlack};
  text-align: left;
`;

export const list = css`
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: left;
`;

export const item = css`
  margin: 0;
  padding: 0;
`;

export const itemSelected = css`
  background-color: ${palette.purple30};
`;

export const link = css`
  display: block;
  margin: ${spacing.xs}px 0;
  padding: ${spacing.base}px 0 ${spacing.base}px ${spacing.md}px;
  color: ${palette.neutralBrandBlack};
  ${primaryRegularFont};
  ${theme.responsiveText.BODY.SM}
  border: 0;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: ${palette.purple30};
  }
`;
